import { useContext } from 'react';
import { useTranslation } from 'next-i18next';
import { Button, ThemeContext } from '@forma/forma-ui-kit';
import Link from '@/components/Link';

import styles from './document-folder.module.css';

const DocumentFolder = (props) => {
  const { t } = useTranslation();
  const { title, docs, translatedName } = props;

  const { viewport } = useContext(ThemeContext);
  const isPhone = viewport === 'phone';

  return (
    <>
      {docs.length !== 0 && (
        <div className={styles.root}>
          <div className={styles.titleBlock}>
            {!isPhone && <img className={styles.icon} src="/icons/explorer/folder_forma.svg" />}
            <div>{title}</div>
          </div>
          <ul>
            {docs.map(
              (elem, index) =>
                index < 4 && (
                  <li key={elem.id} className={styles.link}>
                    {isPhone && (
                      <img className={styles.icon} src="/icons/explorer/folder_forma.svg" />
                    )}
                    <Link href={`/templates/${elem.path}`}>
                      {elem.name}
                    </Link>
                  </li>
                )
            )}
          </ul>
          <Button
            size="small"
            viewStyle="tertiary"
            className={styles.button}
            as={Link}
            href={`/templates/${translatedName}`}
          >
            Еще {t('count_documents', { count: docs.length })}
          </Button>
        </div>
      )}
    </>
  );
};

export default DocumentFolder;
